import styled from 'styled-components';

export const GridSection = styled.section`
  padding: 64px 28px;
  max-width: var(--max-width);
  margin: 0 auto;

  @media (max-width: 600px) { padding: 48px 22px; }
`;

export const Eyebrow = styled.div`
  font-style: italic;
  font-size: 1rem;
  color: var(--ink-muted);
  margin-bottom: 8px;
`;

export const SectionTitle = styled.h2`
  font-family: 'EB Garamond', Georgia, serif;
  font-size: 2rem;
  font-weight: 500;
  letter-spacing: -0.005em;
  color: var(--ink);
  line-height: 1.15;
  margin: 0 0 28px;

  em { font-style: italic; color: var(--accent); }
`;

export const Ornament = styled.div`
  text-align: center;
  font-size: 1.1rem;
  color: var(--rule);
  letter-spacing: 0.6em;
  padding: 12px 0 0;
  user-select: none;

  &::before { content: '❦'; }
`;

export default GridSection;
